const AVATARS = [
  {
    id: "0",
    src: "/images/map-avatars/0.png",
    tooltip: "Default",
  },
  {
    id: "1",
    src: "/images/map-avatars/1.png",
    tooltip: "Hospital",
  },
  {
    id: "2",
    src: "/images/map-avatars/2.png",
    tooltip: "Clinic",
  },
  {
    id: "3",
    src: "/images/map-avatars/3.png",
    tooltip: "Regulated Clinician",
  },
  {
    id: "4",
    src: "/images/map-avatars/4.png",
    tooltip: "Regulated Clinician",
  },
  {
    id: "5",
    src: "/images/map-avatars/5.png",
    tooltip: "Regulated Clinician",
  },
  {
    id: "6",
    src: "/images/map-avatars/6.png",
    tooltip: "Regulated Clinician",
  },
  {
    id: "7",
    src: "/images/map-avatars/7.png",
    tooltip: "Regulated Clinician",
  },
  {
    id: "8",
    src: "/images/map-avatars/8.png",
    tooltip: "Regulated Clinician",
  },
  {
    id: "9",
    src: "/images/map-avatars/9.png",
    tooltip: "Unregulated Healthcare Professional",
  },
  {
    id: "10",
    src: "/images/map-avatars/10.png",
    tooltip: "Unregulated Healthcare Professional",
  },
  {
    id: "11",
    src: "/images/map-avatars/11.png",
    tooltip: "Unregulated Healthcare Professional",
  },
  {
    id: "12",
    src: "/images/map-avatars/12.png",
    tooltip: "Unregulated Healthcare Professional",
  },
  {
    id: "13",
    src: "/images/map-avatars/13.png",
    tooltip: "Unregulated Healthcare Professional",
  },
  {
    id: "14",
    src: "/images/map-avatars/14.png",
    tooltip: "Unregulated Healthcare Professional",
  },
  {
    id: "15",
    src: "/images/map-avatars/15.png",
    tooltip: "Physician",
  },
  {
    id: "16",
    src: "/images/map-avatars/16.png",
    tooltip: "Physician",
  },
  {
    id: "17",
    src: "/images/map-avatars/17.png",
    tooltip: "Physician",
  },
  {
    id: "18",
    src: "/images/map-avatars/18.png",
    tooltip: "Physician",
  },
  {
    id: "19",
    src: "/images/map-avatars/19.png",
    tooltip: "Physician",
  },
  {
    id: "20",
    src: "/images/map-avatars/20.png",
    tooltip: "Physician",
  },
  {
    id: "21",
    src: "/images/map-avatars/21.png",
    tooltip: "Medical Devices, Healthcare Equipments",
  },
  {
    id: "22",
    src: "/images/map-avatars/22.png",
    tooltip: "Healthcare Technology",
  },
  {
    id: "23",
    src: "/images/map-avatars/23.png",
    tooltip: "Facility",
  },
  {
    id: "24",
    src: "/images/map-avatars/24.png",
    tooltip: "Residential",
  },
  {
    id: "25",
    src: "/images/map-avatars/25.png",
    tooltip: "Legal Services",
  },
  {
    id: "26",
    src: "/images/map-avatars/26.png",
    tooltip: "Legal Services",
  },
  {
    id: "27",
    src: "/images/map-avatars/27.png",
    tooltip: "Legal Services",
  },
  {
    id: "28",
    src: "/images/map-avatars/28.png",
    tooltip: "Legal Services",
  },
  {
    id: "29",
    src: "/images/map-avatars/29.png",
    tooltip: "Legal Services",
  },
  {
    id: "30",
    src: "/images/map-avatars/30.png",
    tooltip: "Legal Services",
  },
  {
    id: "31",
    src: "/images/map-avatars/31.png",
    tooltip: "Brain Injury Support",
  },
  {
    id: "32",
    src: "/images/map-avatars/32.png",
    tooltip: "Brain Injury Support",
  },
  {
    id: "33",
    src: "/images/map-avatars/33.png",
    tooltip: "Charity Organization",
  },
  {
    id: "34",
    src: "/images/map-avatars/34.png",
    tooltip: "Crisis Support",
  },
  {
    id: "35",
    src: "/images/map-avatars/35.png",
    tooltip: "Mental Health Services",
  },
  {
    id: "36",
    src: "/images/map-avatars/36.png",
    tooltip: "Autism Services",
  },
  {
    id: "37",
    src: "/images/map-avatars/37.png",
    tooltip:
      "Services for Developmental Disabilities and/or Neurodiverse populations",
  },
  {
    id: "38",
    src: "/images/map-avatars/38.png",
    tooltip: "Occupational Therapy",
  },
  {
    id: "39",
    src: "/images/map-avatars/39.png",
    tooltip: "Occupational Therapy",
  },
  {
    id: "40",
    src: "/images/map-avatars/40.png",
    tooltip: "Shelter Services",
  },
  {
    id: "41",
    src: "/images/map-avatars/41.png",
    tooltip: "Physiotherapy Clinic",
  },
  {
    id: "42",
    src: "/images/map-avatars/42.png",
    tooltip: "Violence Against Women",
  },
  {
    id: "43",
    src: "/images/map-avatars/43.png",
    tooltip: "Home Modifications and Maintenance",
  },
  {
    id: "44",
    src: "/images/map-avatars/44.png",
    tooltip: "Finance Professionals",
  },
  {
    id: "45",
    src: "/images/map-avatars/45.png",
    tooltip: "Driver Assessment & Rehabilitation",
  },
  {
    id: "46",
    src: "/images/map-avatars/46.png",
    tooltip: "Multidisciplinary Network",
  },
  {
    id: "47",
    src: "/images/map-avatars/47.png",
    tooltip: "Vocational Professionals",
  },
  {
    id: "48",
    src: "/images/map-avatars/48.png",
    tooltip: "Pain Managment Professionals",
  },
  {
    id: "49",
    src: "/images/map-avatars/49.png",
    tooltip: "Assessment Professionals",
  },
  {
    id: "50",
    src: "/images/map-avatars/50.png",
    tooltip: "PainHero",
  },
  {
    id: "51",
    src: "/images/map-avatars/51.png",
    tooltip: "Serving Neurodiverse populations & Mental Health",
  },
  {
    id: "52",
    src: "/images/map-avatars/52.png",
    tooltip: "Treaty Three Police",
  },
  {
    id: "53",
    src: "/images/map-avatars/53.png",
    tooltip: "Ontario Provincial Police",
  },
];

export default {
  AVATARS,
};
